import React, { useState } from 'react';
import { InView } from '../InView';
import { PhoneSnak } from '../PhoneSnak';
import { FloatingHearts } from '../FloatingHearts';
import { FerringWordmark } from '../../FerringWordmark';
import { PresentationLogo } from '../../PresentationLogo';
import { ConceptModal } from '../../concept/ConceptModal';
import { snakTraits } from '../../../data/deck';
export function OpeningSection() {
  const [conceptOpen, setConceptOpen] = useState(false);
  return <section id="opening" aria-label="All you need is love" className="relative flex min-h-screen w-full flex-col overflow-hidden bg-[var(--surface)]" data-id="element-510" data-mp="2bppk49rh0ta8">
      <FloatingHearts data-id="element-511" data-mp="2kloty1ybfmr7" />

      <div className="relative flex items-center justify-between gap-4 px-8 pt-6 lg:px-14" data-id="element-512" data-mp="2km8apfc8c53n">
        <div className="flex items-center gap-4" data-id="element-513" data-mp="2frue59ltzrxe">
          <FerringWordmark data-id="element-514" data-mp="1s31f349wx3yk" />
          <span className="h-6 w-px bg-[var(--fg)]/15" aria-hidden="true" data-id="element-515" data-mp="1s29vkrtlawon" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-[var(--fg)]/45" data-id="element-516" data-mp="1o1pwhipghizv">
            REKOVELLE · Follow-up
          </span>
        </div>
        <PresentationLogo data-id="element-517" data-mp="3v7xzmllh8ud1" />
      </div>

      <main className="relative flex flex-1 items-center" data-id="element-518" data-mp="3v6v9ifvzavy6">
        <div className="mx-auto grid w-full max-w-[1440px] items-center gap-14 px-8 py-12 lg:grid-cols-[minmax(0,1fr)_auto] lg:gap-20 lg:px-14 lg:py-8" data-id="element-519" data-mp="3t8q2yr0xajq">
          <div className="max-w-[620px]" data-id="element-520" data-mp="8s3galrbm1dv">
            <InView data-id="element-521" data-mp="37b0oauvr6qqd">
              <h1 className="text-[58px] font-extrabold leading-[0.92] tracking-[-0.055em] text-[var(--fg)] sm:text-[84px]" data-id="element-522" data-mp="37bk5g9dkxb3c">
                All you need is love.
              </h1>
            </InView>
            <InView delay={0.2} className="mt-10" data-id="element-523" data-mp="3h7n5n9oveznn">
              <div className="rounded-2xl bg-white p-5 ring-1 ring-[var(--fg)]/5" data-id="element-524" data-mp="3m7rq1aswgej5">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-525" data-mp="3m5or219rrb2a">A Snak, in one line</p>
                <p className="mt-1.5 text-[16px] font-bold leading-snug text-[var(--fg)]" data-id="element-526" data-mp="11hivzotxkig4">
                  A short, interactive story HCPs take part in — turning important content into something they notice,
                  understand and act on.
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-3" data-id="element-527" data-mp="2snorcgdtghpb">
                  {snakTraits.map(trait => <li key={trait.title} className="rounded-xl bg-[var(--surface)] px-3 py-2" data-id="element-528" data-mp="36j0w7glorojy">
                      <span className="block text-[12px] font-extrabold uppercase tracking-[0.14em] text-[var(--brand)]" data-id="element-529" data-mp="32hxj31v0w6mf">
                        {trait.title}
                      </span>
                      <span className="block text-[12px] leading-snug text-[var(--muted)]" data-id="element-530" data-mp="29t00syqta9to">{trait.body}</span>
                    </li>)}
                </ul>
              </div>
            </InView>

            <InView delay={0.28} className="mt-4" data-id="element-531" data-mp="2ity8br0gkzh0">
              <div className="rounded-2xl bg-white p-5 ring-1 ring-[var(--fg)]/5" data-id="element-532" data-mp="1v4vpwgy032lg">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-533" data-mp="1r5eivj2xdxe6">Meet Snakker™</p>
                <p className="mt-1.5 text-[16px] font-bold leading-snug text-[var(--fg)]" data-id="element-534" data-mp="1gzwi7timoffg">
                  We’re an AI boutique life science agency with a passion for making complex science simple, engaging and
                  memorable.
                </p>
                <p className="mt-2 text-[13.5px] leading-relaxed text-[var(--muted)]" data-id="element-535" data-mp="1c1bp0e1smw0i">
                  Through our interactive Snaks™, we turn complicated clinical information into short, sharp and rewarding
                  experiences for busy healthcare professionals.
                </p>
                <p className="mt-2 text-[13.5px] leading-relaxed text-[var(--muted)]" data-id="element-536" data-mp="1pt8f6cjwivu9">
                  Trusted by leading life science companies including GSK, Roche, Siemens Healthineers, AbbVie, Novartis and
                  LEO Pharma, we combine scientific understanding, creativity and AI to make every interaction count.
                </p>
                <p className="mt-3 text-[13px] font-extrabold tracking-[-0.01em] text-[var(--brand)]" data-id="element-537" data-mp="jeh81r46qers">
                  Short. Sharp. Satisfying.
                </p>
              </div>
            </InView>
          </div>

          <InView delay={0.16} y={26} className="flex justify-center lg:justify-end" data-id="element-538" data-mp="ur99iswz4vv2">
            <div className="flex flex-col items-center gap-5" data-id="element-539" data-mp="puiqpxtsbm5y">
              <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-[var(--fg)]/40" data-id="element-540" data-mp="kw7i1qf87hpb">
                Example Snak · REKOVELLE
              </span>
              <PhoneSnak label="Live REKOVELLE teaser Snak" onConcept={() => setConceptOpen(true)} className="h-[clamp(560px,calc(100vh-240px),800px)]" data-id="element-541" data-mp="1dk3b8l5l6rhc" />
              <span className="text-[11px] font-medium tracking-[0.02em] text-[var(--muted)]" data-id="element-542" data-mp="13m5roayo9iv2">
                Tap to play · about 40 seconds
              </span>
            </div>
          </InView>
        </div>
      </main>

      <footer className="relative px-8 pb-6 lg:px-14" data-id="element-543" data-mp="3ob3iby83y97i">
        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[var(--fg)]/30" data-id="element-544" data-mp="23u42y5g25qwx">
          Concept &amp; creative direction © Snakker™ 2026 · Subject to Ferring medical/legal review
        </p>
      </footer>

      <ConceptModal open={conceptOpen} onClose={() => setConceptOpen(false)} data-id="element-545" data-mp="2drqhurxcxigw" />
    </section>;
}